export function buildProfileDetailsModel(dto) {
  if (!dto) {
    return null;
  }

  return {
    id: dto.id || '-',
    name: dto.name || '-',
    email: dto.email || '-',
    emailMasked: dto.emailMasked || '',
    phone: dto.phone || '-',
    phoneMasked: dto.phoneMasked || '',
    country: dto.country || '-',
    language: dto.language || '-',
    status: dto.status || '-',
    invalid: dto.invalid === true,
    marketingConsent: dto.marketingConsent,
    marketingConsentAt: dto.marketingConsentAt || '',
    consentWithdrawnAt: dto.consentWithdrawnAt || '',
    closureRequestedAt: dto.closureRequestedAt || '',
    legalHoldUntil: dto.legalHoldUntil || '',
    vulnerabilityFlag: dto.vulnerabilityFlag,
    vulnerabilityNotes: dto.vulnerabilityNotes || '',
    legalAcceptances: Array.isArray(dto.legalAcceptances) ? dto.legalAcceptances : [],
    source: dto.source || null,
    rawJson: JSON.stringify(dto.source || {}, null, 2),
  };
}
